import TomSelect from 'tom-select';

const TomSelectHook = {
  mounted() {
    const selectElement = this.el;
    const isMultiselect = selectElement.hasAttribute('multiple');
    const changeEvent = selectElement.dataset.changeEvent;
    
    console.log('TomSelect mounted:', {
      id: selectElement.id,
      isMultiselect,
      changeEvent
    });
    
    const config = {
      plugins: isMultiselect ? ['remove_button'] : [],
      maxOptions: 1000,
      maxItems: isMultiselect ? null : 1,
      create: false,
      placeholder: 'Search...',
      searchField: ['text'],
      sortField: {
        field: "text",
        direction: "asc"
      },
      score: function(search) {
        const score = this.getScoreFunction(search);
        return function(item) {
          if (item.text.toLowerCase().startsWith(search.toLowerCase())) {
            return 1;
          }
          return score(item) * 0.5;
        };
      }
    };

    const tomSelect = new TomSelect(selectElement, config);
    
    selectElement._tomSelect = tomSelect;

    const selectedValues = Array.from(selectElement.selectedOptions).map(opt => opt.value);
    if (selectedValues.length > 0) {
      console.log('Setting initial values:', selectedValues);
      tomSelect.setValue(selectedValues, true);
    }

    if (changeEvent) {
      tomSelect.on('change', (value) => {
        const values = Array.isArray(value) ? value : (value ? [value] : []);
        console.log('TomSelect changed, pushing event:', changeEvent, values);
        this.pushEvent(changeEvent, { value: values });
      });
    } else {
      tomSelect.on('change', (value) => {
        selectElement.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    if (selectElement.id) {
      this.handleEvent(`reset_multiselect_${selectElement.id}`, () => {
        console.log('Resetting TomSelect:', selectElement.id);
        tomSelect.clear();
      });
      
      this.handleEvent(`clear_${selectElement.id}`, () => {
        tomSelect.clear(true);
      });
      
      this.handleEvent(`update_${selectElement.id}`, (data) => {
        tomSelect.clearOptions();
        tomSelect.addOptions(data.options);
        tomSelect.refreshOptions(false);
      });
    }
  },

  updated() {
    const selectElement = this.el;
    const tomSelect = selectElement._tomSelect;
    
    if (tomSelect) {
      const selectedValues = Array.from(selectElement.selectedOptions).map(opt => opt.value);
      const currentValues = tomSelect.getValue();
      
      const selectedArray = Array.isArray(selectedValues) ? selectedValues : [selectedValues];
      const currentArray = Array.isArray(currentValues) ? currentValues : (currentValues ? [currentValues] : []);
      
      if (JSON.stringify(selectedArray.sort()) !== JSON.stringify(currentArray.sort())) {
        console.log('Updating TomSelect values from', currentArray, 'to', selectedArray);
        tomSelect.setValue(selectedValues, true);
      }
    }
  },

  destroyed() {
    if (this.el._tomSelect) {
      this.el._tomSelect.destroy();
      delete this.el._tomSelect;
    }
  }
};

export default TomSelectHook;